var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.record)?_c('edit',{attrs:{"record":_vm.record,"editMode":true},on:{"onGoBack":_vm.handleGoBack}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }